import { call, put, takeLeading } from 'redux-saga/effects';
import { sendError } from '../../../';
import { API, RequestOptions } from '../../../../api';
import { getOrderAPI } from '../../../../helpers';
import {
    marketsData,
    marketsError,
    MarketsFetch,
    marketsTickersData,
    marketsTickersError,
    MarketsTickersFetch,
    setCurrentMarketIfUnset,
} from '../actions';
import { MARKETS_FETCH, MARKETS_TICKERS_FETCH } from '../constants';
import { Market } from '../types'; // Add this import statement
import { SagaIterator } from 'redux-saga';
const marketsRequestOptions: RequestOptions = {
    apiVersion: getOrderAPI(),
};

const tickersOptions: RequestOptions = {
    apiVersion: 'peatio',
};

export function* rootMarketsSaga() {
    yield takeLeading(MARKETS_FETCH, marketsFetchSaga);
    yield takeLeading(MARKETS_TICKERS_FETCH, tickersSaga);
}



export function* marketsFetchSaga(action: MarketsFetch): Generator<any, void, Market[]> {
    try {
        const markets = yield call(API.get(marketsRequestOptions), '/public/markets');
        yield put(marketsData(markets));
        yield put(setCurrentMarketIfUnset(markets[0]));
    } catch (error) {
        yield put(sendError({
            error,
            processingType: 'alert',
            extraOptions: {
                actionError: marketsError,
            },
        }));
    }
}

export function* tickersSaga(action: MarketsTickersFetch): SagaIterator {
    try {
        const tickers = yield call(API.get(tickersOptions), `/public/markets/tickers`);

        if (tickers) {
            const pairs = Object.keys(tickers);

            const convertedTickers = pairs.reduce((result: any, pair) => {
                result[pair] = tickers[pair].ticker;

                return result;
            }, {});
            yield put(marketsTickersData(convertedTickers));
        }
    } catch (error) {
        yield put(sendError({
            error,
            processingType: 'alert',
            extraOptions: {
                actionError: marketsTickersError,
            },
        }));
    }
}
